import { render } from "./Col.vue?vue&type=template&id=53c0aeb3&scoped=true"
import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"

import "./Col.vue?vue&type=style&index=0&id=53c0aeb3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-53c0aeb3"

export default script